export default {
  // 模块名称
  reserve: {
    // 按钮类
    button: {
      newplan: '新增预案',
      save: '保存',
      reset: '重置',
      conform: '保存',
      cancel: '取消',
      prompt: '提示',
      whole: '全选',
      search: '查询',
      close: '关闭',
      review: '复核',
      assign: '指派',
      frame: '框选',
      modify: '修改',
      disadled: '禁用',
      abled: '启用',
      look: '详情',
      delete: '删除',
      add: '添加'
    },
    // 文字标签类
    label: {
      openperson: '创建人',
      createTime: '创建时间',
      open: '状态',
      class: '预案分类',
      preplanname: '预案名称',
      classificationofplans: '预案类型',
      preplanlevel: '预案级别',
      range: '优先级范围',
      to: '至',
      ruleName: '规则名称',
      ruleStatus: '规则状态',
      no: '序号',
      name: '联动名称',
      statusName: '状态',
      priority: '优先级',
      creator: '创建人',
      modifier: '最后修改人',
      modifyTime: '最后修改时间',
      subSystemNames: '子系统',
      typeName: '联动规则类型',
      optionsmenu: '操作',
      either: '是否确定',
      eitherDel: '您确定删除该预案吗？',
      ruleFile: '联动触发日志',
      dateRule: '日期范围',
      result: '触发结果',
      alarmType: '告警/事件类型',
      alarmDev: '告警设备名称',
      rulrDev: '联动设备',
      lookDetail: '详情',
      triggerTime: '触发时间',
      alarmId: '报警/事件ID',
      alarmDevId: '告警设备编码',
      alarmLevel: '告警级别',
      urgent: '紧急',
      serious: '严重',
      general: '一般',
      ordinary: '普通',
      fail: '失败',
      succ: '成功',
      ruleCode: '触发规则编码',
      ruleNames: '触发规则名称',
      linkDeviceName: '联动设备',
      triggerName: '执行动作',
      mixDev: '指定设备',
      addDevice: '添加设备',
      addDevices: '设备',
      alarmEvent: '告警/事件类型',
      content: '内容:',
      DeviceName: '设备名称',
      up: '上移',
      down: '下移',
      sysNotice: '系统消息通知',
      triggerRes: '执行结果',
      ruleClean: '规则说明',
      condition: '触发条件',
      order: '执行顺序',
      noData: '暂无数据',
      alarmCenter: '告警中心',
      limit: '联动管理'
    },
    // 提示类
    placeholder: {
      enterRule: '请输入联动名称',
      startTime: '开始日期',
      choosestartTime: '请选择开始日期',
      endTime: '结束日期',
      noticeMode: '系统消息标准模板',
      pleChoose: '请选择',
      filter: '输入关键字进行过滤',
      preplanname: '请输入预案名称',
      preplannameStep: '请输入预案步骤名称',
      classificationofplans: '请选择预案类型',
      preplanlevel: '请选择预案级别',
    },
    // 消息类
    message: {
      alarmType: '请选择告警类型',
      step: '请选择预案步骤',
      start: '开始优先级必须输入范围为1-99999的正整数',
      end: '结束优先级必须输入范围为1-99999的正整数',
      startGebd: '起始优先级必须小于等于结束优先级',
      delSucc: '删除成功',
      calDel: '取消删除',
      disableOne: '指定设备与联动设备不能为同一个',
      sysNoSet: '系统消息通知未设置',
      smsNoSet: '短信消息通知未设置',
      noCheck: '未选中要删除的动作',
      disableDel: '是否删除选择的动作？',
      addMost: '同一个联动规则最多添加20个指定联动设备',
      searcFail: '查询失败',
      doing: '执行中',
      doSuc: '执行成功',
      doFail: '执行失败',
      heigher: '请填写优先级(1-99999),数字越小，优先级越高',
      parseInt: '优先级输入范围为1-99999的正整数',
      ruleNameLen: '规则名称长度必须是4到50个字符',
      addruleSuc: '新增联动规则成功',
      modifyRuleSuc: '修改联动规则成功',
      almostFinish: '至少完善一条子系统的所有触发条件',
      taskDescRequired: '请输入任务描述',
      taskDescLength: '任务描述长度不能超过200',
    },
    // 标题类
    title: {
      steplist: '预案步骤列表',
      list: '告警类型列表',
      checktype: '已选告警类型',
      checkstep: '已选预案步骤',
      alarm: '子系统类型',
      step: '预案步骤',
      msg: '基础信息',
      name: '预案详情',
      addRule: '新增规则',
      ret: '返回',
      noticeSet: '通知模板设置',
      noticePerson: '通知人员',
      sysNotice: '系统消息',
      ruleDetail: '联动触发日志详情',
      ruleAction: '联动动作',
      noteiceSet: '通知设置',
      addRules: '新增联动规则',
      lookRule: '查看联动规则详情',
      modifyRule: '修改联动规则'
    }
  }
}
